<template>
  <div class="ma-4">
    <v-toolbar>
      <v-toolbar-title>SERVE Admin</v-toolbar-title>
      <v-spacer />
      <v-select v-model="term" :items="terms" label="Term" outlined hide-details dense class="mt-1 mr-2" style="max-width:200px" />
    </v-toolbar>
    <v-tabs v-model="tab">
      <v-tab>Student Assigments</v-tab>
      <v-tab>Supervisors/Areas</v-tab>
      <v-spacer />
      <email-dialog v-if="tab === 0 && filteredStudents.length > 0" :data="filteredStudents" :mergeFields="[{ label: 'Assignment', value: 'currentAssignment.assignment' }, { label: 'Hours', value: 'currentAssignment.hours' }]">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="mr-2">
            <v-icon left>fal fa-envelope</v-icon>
            Email Students
          </v-btn>
        </template>
      </email-dialog>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-alert v-if="!dataLoaded" type="info">Loading...</v-alert>
        <v-toolbar v-if="dataLoaded" style="overflow-x:auto">
          <v-text-field v-model="filter.name" label="Name Search" dense hide-details outlined class="mt-1 mx-1" style="max-width:200px" />
          <v-select v-model="filter.hall" :items="halls" label="Hall Filter" dense hide-details outlined clearable class="mt-1" style="max-width:200px" />
          <v-text-field v-model="filter.hour" label="Hour Filter" type="number" dense hide-details outlined clearable class="mt-1 mx-1" style="max-width:200px" />
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" outlined style="margin-top:2px">
                <span v-if="filter.assignment.length === 0">Assignment Filter</span>
                <span v-else-if="filter.assignment.length === 1">{{ filter.exclude ? 'Excluding' : 'Including' }} {{ filter.assignment[0] }}</span>
                <span v-else>{{ filter.exclude ? 'Excluding' : 'Including' }} {{ filter.assignment.length }} Assignments</span>
                <v-icon right>fal fa-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card style="width:600px">
              <v-card-text>
                <v-switch v-model="filter.exclude" :label="filter.exclude ? 'Excluding Selected' : 'Including Selected'" />
                <v-row>
                  <v-col :cols="4">
                    <v-card>
                      <v-list dense>
                        <v-subheader>Main</v-subheader>
                        <v-list-item v-for="{ area, count } of counts.filter(({ category }) => category === 'Main')" :key="area" :style="filter.assignment.includes(area) ? 'background-color:#87BEF0' : ''" @click="toggleAssignmentFilter(area)">
                          <v-list-item-title>{{ area }}</v-list-item-title>
                          <v-list-item-action>
                            <v-avatar color="#193264" class="white--text" right size="32">{{ count }}</v-avatar>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <v-subheader>Sophomores</v-subheader>
                        <v-list-item v-for="{ area, count } of counts.filter(({ category }) => category === 'Sophomores')" :key="area" :style="filter.assignment.includes(area) ? 'background-color:#87BEF0' : ''" @click="toggleAssignmentFilter(area)">
                          <v-list-item-title>{{ area }}</v-list-item-title>
                          <v-list-item-action>
                            <v-avatar color="#193264" class="white--text" right size="32">{{ count }}</v-avatar>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col :cols="8">
                    <v-card>
                      <v-subheader>Athletics</v-subheader>
                      <v-row>
                        <v-col v-for="{ area, count } of counts.filter(({ category }) => category === 'Athletics')" :key="area" :cols="6" class="py-0">
                          <v-list dense>
                            <v-list-item :style="filter.assignment.includes(area) ? 'background-color:#87BEF0' : ''" @click="toggleAssignmentFilter(area)">
                              <v-list-item-title>{{ area }}</v-list-item-title>
                              <v-list-item-action class="my-0">
                                <v-avatar color="#193264" class="white--text" right size="32">{{ count }}</v-avatar>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-card class="mt-2">
                      <v-list dense>
                        <v-list-item :style="filter.assignment.includes('unassigned') ? 'background-color:#87BEF0' : ''" @click="toggleAssignmentFilter('unassigned')">
                          <v-list-item-title>Not Placed</v-list-item-title>
                          <v-list-item-action>
                            <v-avatar color="#193264" class="white--text" right size="32">{{ unassignedCount }}</v-avatar>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-select v-model="filter.workstudy" :items="workStudyOptions" label="ScotsWork Placement" dense hide-details outlined multiple chips small-chips class="mt-1 mx-1" style="max-width:200px">
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0" small>{{ item }}</v-chip>
              <span v-if="index === 1" class="grey--text text-caption">(+{{ filter.workstudy.length - 1 }} other{{ filter.workstudy.length > 2 ? 's': '' }})</span>
            </template>
          </v-select>
          <!-- <v-select v-model="showCategory" :items="categories" label="Category" dense hide-details outlined class="mr-1" style="max-width:180px" />
          <v-btn-toggle v-model="filter.assignment">
            <v-btn v-for="{ area, count } in countsFiltered" :key="area" :value="area">
              {{ area }}
              <v-avatar color="#193264" class="white--text ml-2" right size="32">{{ count }}</v-avatar>
            </v-btn>
            <v-btn v-if="unassignedCount > 0" :value="'unassigned'">
              Not Placed
              <v-avatar color="#193264" class="white--text ml-2" right size="32">{{ unassignedCount }}</v-avatar>
            </v-btn>
          </v-btn-toggle> -->
        </v-toolbar>
        <v-data-table v-if="dataLoaded" :items="filteredStudents" :headers="headers">
          <template v-slot:item.currentAssignment.assignment="{ item }">
            <span v-if="item.startTerm > term.value">**Not a student in selected term**</span>
            <v-menu v-else>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" label outlined>{{ item.currentAssignment && item.currentAssignment.assignment ? item.currentAssignment.assignment : 'Choose Placement' }}
                  <v-icon v-if="!item.currentAssignment || !item.currentAssignment.assignment" right>fal fa-chevron-down</v-icon>
                </v-chip>
              </template>
              <v-list dense>
                <template v-for="{ category, areas } of groupedAreas">
                  <v-subheader :key="category + '-header'">{{ category }}</v-subheader>
                  <v-list-item v-for="area of areas" :key="area" dense @click="setAssignment({ id: item.currentAssignment.id, area, pidm: item.pidm })">{{ area }}</v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.currentAssignment.hours="{ item }">
            <v-tooltip v-if="item.currentAssignment && 'committed' in item.currentAssignment && item.currentAssignment.committed > 0" top>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" label outlined @click="openDetail(item)">
                  <v-icon left x-small color="info">fas fa-exclamation</v-icon>
                  {{ item.currentAssignment.committed ? item.currentAssignment.committed + (item.currentAssignment.hours || 0) : item.currentAssignment.hours || 0 }}
                </v-chip>
              </template>
              <span>Committed to {{ item.currentAssignment.committed }} hours and completed {{ item.currentAssignment.hours || 0 }} hours</span>
            </v-tooltip>
            <v-chip v-else-if="item.currentAssignment && item.currentAssignment.hours" label outlined @click="openDetail(item)">{{ item.currentAssignment.hours || 0 }}</v-chip>
          </template>
          <template v-slot:item.assignments="{ item }">
            <v-chip v-for="{ assignment, term, hours } in item.assignments" :key="assignment + '-' + term" label outlined>{{ term.join('/') }} - {{ assignment }} - Hours: {{ hours }}</v-chip>
          </template>
          <!-- <template v-slot:item.fallAssignment="{ item }">
            <span v-if="item.startTerm.substring(5, 2) === '05'">**Started in Spring**</span>
            <v-menu v-else>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" label outlined>{{ item.fallAssignment && item.fallAssignment.assignment ? item.fallAssignment.assignment : 'Choose Placement' }}
                  <v-icon v-if="!(item.fallAssignment && item.fallAssignment.assignment)" right>fal fa-chevron-down</v-icon>
                </v-chip>
              </template>
              <v-list dense>
                <template v-for="{ category, areas } of groupedAreas">
                  <v-subheader :key="category + '-header'">{{ category }}</v-subheader>
                  <v-list-item v-for="area of areas" :key="area" dense @click="setAssignment({ id: item.fallAssignment.id, area, pidm: item.pidm })">{{ area }}</v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:item.fallHours="{ item }">
            <v-tooltip v-if="item.fallAssignment && 'committed' in item.fallAssignment && item.fallAssignment.committed > 0" top>
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" label outlined @click="openDetail(item)">
                  <v-icon left x-small color="info">fas fa-exclamation</v-icon>
                  {{ item.fallAssignment.committed ? item.fallAssignment.committed + (item.fallAssignment.hours || 0) : item.fallAssignment.hours || 0 }}
                </v-chip>
              </template>
              <span>Committed to {{ item.fallAssignment.committed }} hours and completed {{ item.fallAssignment.hours || 0 }} hours</span>
            </v-tooltip>
            <v-chip v-else-if="item.fallAssignment" label outlined @click="openDetail(item)">{{ item.fallAssignment.hours || 0 }}</v-chip>
          </template> -->
          <!-- <template v-slot:item.springAssignment="{ item }">
            <v-chip v-if="item.springAssignment && item.springAssignment.assignment" label outlined>{{ item.springAssignment.assignment }}</v-chip>
            <v-select v-else :items="areas.map(({ area: a }) => a)" label="Placement" outlined solo dense hide-details @change="(area) => setAssignment({ id: item.springAssignment.id, area, pidm: item.pidm })" style="max-width:250px" />
          </template>
          <template v-slot:item.springHours="{ item }">
            <v-chip v-if="item.springAssignment" label outlined>{{ item.springAssignment.hours || 0 }}</v-chip>
          </template> -->
          <template v-slot:item.workstudy="{ item }">
            <v-chip v-for="{ _id, desc } of item.workstudy" :key="_id" label class="mr-1">{{ desc }}</v-chip>
          </template>
        </v-data-table>
        <v-dialog v-model="detailDialog" width="800">
          <serve-detail :bannerId="detailId">
            <v-card-actions>
              <v-btn text @click="detailDialog = false">Close</v-btn>
            </v-card-actions>
          </serve-detail>
        </v-dialog>
      </v-tab-item>
      <v-tab-item>
        <areas />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { onMounted, ref, computed, watch } from '@vue/composition-api'

export default {
  components: {
    Areas: () => import('@/components/serve/areas'),
    ServeDetail: () => import('@/components/serve/detail'),
    EmailDialog: () => import('@/components/system/emailDialog')
  },
  setup (props, { root }) {
    const tab = ref(0)
    const term = ref('')
    const terms = ref([])
    const showCategory = ref('Main')
    const categories = ref([])
    const groupedAreas = ref([])
    const counts = ref([])
    const unassignedCount = ref(0)
    const countsFiltered = computed(() => counts.value.filter(({ category }) => category === showCategory.value))
    const headers = computed(() => {
      const arr = [
        { text: 'Banner ID', value: 'bannerId' },
        { text: 'Last Name', value: 'last' },
        { text: 'First Name', value: 'first' },
        { text: 'Start Term', value: 'startTerm' }
      ]
      const termRec = terms.value.find(({ value }) => value === term.value)
      if (termRec) {
        arr.push({ text: termRec.text + ' Assignment', value: 'currentAssignment.assignment', sortable: false })
        arr.push({ text: termRec.text + ' Hours', value: 'currentAssignment.hours', sortable: false })
      }
      // if (term.value.substring(4, 6) === '05') {
      //   const year = parseInt(term.value.substring(0, 4))
      //   arr.push({ text: `Fall ${(year - 1)} Assignment`, value: 'fallAssignment' })
      //   arr.push({ text: `Fall ${(year - 1)} Hours`, value: 'fallHours' })
      //   arr.push({ text: `Spring ${year} Assignment`, value: 'springAssignment' })
      //   arr.push({ text: `Spring ${year} Hours`, value: 'springHours' })
      // } else {
      //   const year = parseInt(term.value.substring(0, 4))
      //   // arr.push({ text: `Spring ${year} Assignment`, value: 'springAssignment' })
      //   // arr.push({ text: `Spring ${year} Hours`, value: 'springHours' })
      //   arr.push({ text: `Fall ${(year)} Assignment`, value: 'fallAssignment' })
      //   arr.push({ text: `Fall ${(year)} Hours`, value: 'fallHours' })
      // }
      arr.push({ text: 'ScotsWork Placement', value: 'scotswork' })
      arr.push({ text: 'Other Assignments', value: 'assignments' })
      return arr
    })
    const isLoading = ref(false)
    const loadingProgress = ref(0)

    const workStudyOptions = ref([])
    const filter = ref({
      name: '',
      exclude: false,
      assignment: [],
      hall: '',
      hour: null,
      workstudy: [],
      workstudyInvert: false
    })
    function toggleAssignmentFilter (code) {
      const index = filter.value.assignment.findIndex((val) => val === code)
      if (index >= 0) filter.value.assignment.splice(index, 1)
      else filter.value.assignment.push(code)
    }
    const halls = ref([])
    const students = ref([])
    const filteredStudents = computed(() => students.value.filter(({ assignments, currentAssignment, year: y, hall, last, first, scotswork }) => {
      const { assignment, hall: fHall, name: fName, hour, exclude, workstudy } = filter.value
      if (assignment.length > 0) {
        let rec = assignments.find(({ term: t }) => t.includes(term.value))
        if (rec == null && currentAssignment.term.includes(term.value)) {
          rec = currentAssignment
        }
        // Includes means rec.assignment is in the list or "unassigned" is in the list and rec.assignment is either null or empty
        if (!exclude && !assignment.includes(rec.assignment) && !(assignment.includes('unassigned') && (rec.assignment == null || rec.assignment === ''))) return false
        // Exclude means rec.assignemt is not in the list or "unassigned" is in the list and rec.assignment is not null or empty
        else if (exclude && (assignment.includes(rec.assignment) || (assignment.includes('unassigned') && (rec.assignment == null || rec.assignment === '')))) return false
      }

      if (fHall != null && fHall !== '' && fHall !== hall) return false

      if (fName !== '' && fName != null) {
        const regex = new RegExp(fName, 'ig')
        if (!regex.test(last + ', ' + first + ' ' + last)) return false
      }

      if (hour != null && hour !== '') {
        return (currentAssignment.hours || 0) + (currentAssignment.committed || 0) <= parseInt(hour)
      }

      if (workstudy.length > 0) return workstudy.includes(scotswork)
      return true
    }))
    const dataLoaded = ref(false)
    async function loadStudents () {
      dataLoaded.value = false
      const aidy = parseInt(term.value.substring(2, 4)) * 101 + (term.value.substring(4, 6) === '60' ? 1 : -100) + ''
      const aggregate = [
        { $lookup: {
          from: 'WorkStudy-Students',
          localField: 'pidm',
          foreignField: 'pidm',
          as: 'scotswork',
          pipeline: [{ $match: { aidy } }]
        } },
        { $addFields: { scotswork: { $first: '$scotswork' } } },
        { $group: {
          _id: { pidm: '$pidm', bannerId: '$bannerId', last: '$last', first: '$first', email: '$email', startTerm: '$startTerm', hall: '$hall', scotswork: '$scotswork' },
          assignments: {
            $push: { assignment: '$assignment', term: '$term', hours: '$hours', id: '$_id' }
          }
        } },
        { $match: { 'assignments.term': term.value } },
        { $project: {
          pidm: '$_id.pidm',
          bannerId: '$_id.bannerId',
          last: '$_id.last',
          first: '$_id.first',
          email: '$_id.email',
          hall: '$_id.hall',
          startTerm: '$_id.startTerm',
          assignments: 1,
          scotswork: '$_id.scotswork.code'
        } },
        { $sort: { last: 1, first: 1 } }
      ]
      const { total, data } = await root.$feathers.service('serve/student').find({ query: { aggregate } })
      if (total === 0) {
        alert('The selected term has not been set up yet. Please contact Technology Services to import the new students.')
        return
      }

      halls.value = []
      const swList = []
      students.value = data.map((row) => {
        if (row.scotswork && !swList.includes(row.scotswork)) swList.push(row.scotswork)
        if (!halls.value.includes(row.hall)) halls.value.push(row.hall)
        if (row.assignments) {
          row.currentAssignment = row.assignments.find(({ term: t }) => Array.isArray(t) && t.includes(term.value))
          row.assignments = row.assignments.filter(({ term: t }) => !Array.isArray(t) || !t.includes(term.value))
        }
        return row
      })
      swList.sort()
      workStudyOptions.value = swList
      halls.value.sort()
      dataLoaded.value = true
    }
    async function loadCounts () {
      const aggregate = [
        { $match: { active: true } },
        { $lookup: {
          from: 'Serve-Students',
          localField: 'area',
          foreignField: 'assignment',
          as: 'count',
          pipeline: [{ $match: { term: term.value } }]
        } },
        { $addFields: { count: { $size: '$count' } } },
        { $sort: { category: 1, area: 1 } }
      ]
      const { data } = await root.$feathers.service('serve/area').find({ query: { aggregate } })
      const hash = {}
      data.forEach(({ category, area }) => {
        if (!categories.value.includes(category)) categories.value.push(category)
        if (!(category in hash)) hash[category] = []
        hash[category].push(area)
      })
      groupedAreas.value = []
      for (const category in hash) {
        groupedAreas.value.push({ category, areas: hash[category] })
      }
      groupedAreas.value.reverse()
      counts.value = data
      const { total } = await root.$feathers.service('serve/student').find({ query: { term: term.value, $or: [{ assignment: '' }, { assignment: { $exists: false } }], $limit: 0 } })
      unassignedCount.value = total
    }
    watch(term, () => {
      if (term.value) {
        loadStudents()
        loadCounts()
      }
    })

    const areas = ref([])
    async function loadAreas () {
      const { data } = await root.$feathers.service('serve/area').find({ query: { $populate: 'supervisors' } })
      areas.value = data
    }

    onMounted(() => {
      loadAreas()
      // Load the terms for the term dropdown
      const dt = new Date()
      dt.setMonth(dt.getMonth() + 2)
      root.$feathers.service('system/term').find({ query: { term: { $gte: '202360', $regex: '(05|60)$' }, start: { $lte: dt }, $select: ['term', 'label'], $sort: { start: -1 } } }).then(({ data }) => {
        terms.value = data.map(({ term, label }) => { return { text: label, value: term } })
        term.value = data[0].term
      })
    })

    async function setAssignment ({ id, area, pidm }) {
      const rec = areas.value.find(({ area: a }) => a === area)
      console.log(rec)
      const patch = { assignment: area }
      if (rec) {
        if (rec.target) patch.target = rec.target
        patch.term = [term.value]
        if (rec.terms === 2 && term.value.substring(4, 6) === '60') {
          const temp = (parseInt(term.value) + 45) + ''
          patch.term.push(temp)
        }
      }
      const data = await root.$feathers.service('serve/student').patch(id, patch)
      const index = students.value.findIndex(({ pidm: p }) => p === pidm)
      if (index >= 0) {
        const temp = { ...students.value[index] }
        temp.fallAssignment.assignment = data.assignment
        students.value.splice(index, 1, temp)
        loadCounts()
      }
    }

    async function updateAssignment (id, placement) {
      const temp = await root.$feathers.service('serve/student').patch(id, { placement })
      const index = students.value.findIndex(({ _id }) => _id === id)
      if (index >= 0) {
        students.value.splice(index, 1, temp)
      }
    }

    const detailDialog = ref(false)
    const detailId = ref('')
    function openDetail ({ bannerId }) {
      detailId.value = bannerId
      detailDialog.value = true
    }

    return {
      tab,
      term,
      terms,
      showCategory,
      categories,
      groupedAreas,
      counts,
      unassignedCount,
      countsFiltered,
      headers,
      isLoading,
      loadingProgress,
      workStudyOptions,
      filter,
      toggleAssignmentFilter,
      halls,
      students,
      filteredStudents,
      dataLoaded,
      loadStudents,
      areas,
      setAssignment,
      updateAssignment,
      detailDialog,
      detailId,
      openDetail
    }
  }
}
</script>
